import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCircleQuestionmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 16v.01M12 13c0-1.6392 2-1.0681 2-3 0-1.1046-.8954-2-2-2-.7403 0-1.3866.4022-1.7324 1M21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9"
    />
  </svg>
)
export default SvgCircleQuestionmark
